import axiosClient from '@/core/axiosClient'
const resource = '/api/authorization'

export default {
  validate (dto: any) {
    return axiosClient.post(`${resource}/validate`, dto)
  },
  forgot (dto: any) {
    return axiosClient.post(`${resource}/forgot`, dto)
  }
}
